module.exports = __webpack_public_path__ + "img/geo.df0705d4.svg";